export default __webpack_public_path__ + "static/media/miguel-lopes-29.ce1293c5.jpg";